<template>
  <div class="modal">
    <div class="modal-window">
      <div class="modal-header top-line flex-between">
        <h3 class="title">Добавление нового вопроса</h3>
        <div class="close" @click="onCancel">
          <svg width="20" height="20">
            <path class="fil0"
                  d="M0.13 3.611c0,0.2 0.055,0.503 0.112,0.632 0.111,0.251 0.377,0.382 0.559,0.587l1.136 1.155c0.009,0.008 0.022,0.018 0.031,0.026l0.682 0.693c0.012,0.012 0.046,0.045 0.059,0.056 0.009,0.008 0.021,0.019 0.03,0.027l0.598 0.604c0.006,0.006 0.086,0.08 0.09,0.083l0.502 0.528c0.059,0.059 0.045,0.043 0.09,0.082 0.009,0.008 0.022,0.019 0.031,0.026 0.009,0.008 0.022,0.018 0.032,0.026l1.437 1.426c0.082,0.072 0.128,0.106 0.212,0.19 0.127,0.126 0.261,0.304 0.356,0.445 -0.406,0.272 -3.933,3.905 -4.596,4.568 -0.272,0.272 -0.502,0.501 -0.774,0.773 -0.233,0.233 -0.587,0.523 -0.587,0.959 0,0.622 0.152,0.696 0.559,1.103l1.718 1.718c0.769,0.769 1.231,0.982 2.062,0.143 0.666,-0.672 5.116,-5.218 5.512,-5.484 0.194,0.29 0.802,0.862 1.116,1.176l3.877 3.854c0.095,0.084 0.111,0.103 0.198,0.203 1.351,1.564 2.061,0.374 3.128,-0.694 0.955,-0.955 2.183,-1.688 0.947,-2.922 -0.143,-0.143 -0.247,-0.175 -0.405,-0.34 -0.146,-0.153 -0.212,-0.298 -0.375,-0.427l-2.7 -2.683c-0.191,-0.251 -1.141,-1.059 -1.384,-1.365 -0.068,-0.086 -0.097,-0.146 -0.176,-0.225 -0.079,-0.079 -0.139,-0.111 -0.224,-0.178 -0.1,-0.078 -0.116,-0.108 -0.222,-0.179 0.265,-0.395 4.661,-4.694 5.456,-5.483 0.829,-0.825 0.704,-1.273 -0.086,-2.063 -0.291,-0.29 -0.54,-0.539 -0.831,-0.83l-1.259 -1.261c-0.322,-0.287 -0.927,-0.293 -1.281,-0.051 -0.332,0.228 -5.7,5.677 -5.779,5.794 -0.188,-0.127 -0.246,-0.159 -0.416,-0.329 -0.076,-0.076 -0.128,-0.121 -0.196,-0.204l-1.736 -1.758c-0.149,-0.113 -0.251,-0.204 -0.377,-0.368 -0.258,-0.339 -1.168,-1.085 -1.536,-1.557 -0.146,-0.187 -0.251,-0.211 -0.423,-0.379 -0.162,-0.159 -0.202,-0.251 -0.341,-0.403 -0.144,-0.158 -0.267,-0.197 -0.432,-0.37 -0.14,-0.147 -0.184,-0.266 -0.357,-0.387 -0.234,-0.162 -0.522,-0.202 -0.829,-0.202 -0.498,0 -1.408,1.093 -1.762,1.446 -0.406,0.407 -1.446,1.226 -1.446,1.819z"/>
          </svg>
        </div>
      </div>
      <form @submit.prevent="createQuestion">
        <div class="modal-text">

          <div class="form-group">
            <label for="name">Текст <sup>*</sup></label>
            <input type="text" id="name" v-model="question.text" ref="firstInput"
                   v-validate="'required'" name="текст">
            <p class="error" v-if="errors.has('текст')">{{ errors.first('текст') }}</p>
          </div>
          <!--<div class="form-group">
            <label for="description">Описание</label>
            <textarea id="description" name="описание" rows="2"
                      v-model="test.description" v-validate="'required'"></textarea>
          </div>-->
        </div>
        <div class="actions">
          <div class="btn btn-light" @click="onCancel">Отмена</div>
          <button class="btn" type="submit">Создать</button>
        </div>
      </form>

    </div>
  </div>
</template>

<script>
  export default {
    name: 'NewTestModal',
    data () {
      return {
        question: {
          text: '',
          image: ''
        }
      }
    },
    methods: {
      onCancel () {
        this.$emit('cancel')
      },
      createQuestion () {
        this.$validator.validateAll().then((result) => {
            if (result) {
              this.$emit('createQuestion', this.question)
            }
          }
        )
      }
    },
    mounted () {
      this.question = {
        text: '',
        image: ''
      }
      this.$refs.firstInput.focus()
    }
  }
</script>

<style scoped lang="scss">
  .modal {
    &-header {
      .title {
        margin: 0;
      }
    }
  }

  .actions {
    margin-top: 30px;
    .btn {
      width: 180px;
      box-sizing: border-box;
      padding-top: 15px;
      padding-bottom: 15px;
      font-size: 18px;
      margin: 0 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/NewQuestionModal.vue